export class CountriesInfo {

  static Provinces = [
      // Canada
      {code: 'AB', country: 'CA', name: 'Alberta', timezone: 'America/Edmonton'},
      {code: 'BC', country: 'CA', name: 'British Columbia', timezone: 'America/Vancouver'},
      {code: 'MB', country: 'CA', name: 'Manitoba', timezone: 'America/Winnipeg'},
      {code: 'NB', country: 'CA', name: 'New Brunswick', timezone: 'America/Moncton'},
      {code: 'NL', country: 'CA', name: 'Newfoundland and Labrador', timezone: 'America/St_Johns'},
      {code: 'NT', country: 'CA', name: 'Northwest Territories', timezone: 'America/Yellowknife'},
      {code: 'NS', country: 'CA', name: 'Nova Scotia', timezone: 'America/Halifax'},
      {code: 'NU', country: 'CA', name: 'Nunavut', timezone: 'America/Iqaluit'},
      {code: 'ON', country: 'CA', name: 'Ontario', timezone: 'America/Toronto'},
      {code: 'PE', country: 'CA', name: 'Prince Edward Island', timezone: 'America/Halifax'},
      {code: 'QC', country: 'CA', name: 'Quebec', timezone: 'America/Montreal'},
      {code: 'SK', country: 'CA', name: 'Saskatchewan', timezone: 'America/Regina'},
      {code: 'YT', country: 'CA', name: 'Yukon Territory', timezone: 'America/Whitehorse'},
      // USA
      {code: 'AL', country: 'US', name: 'Alabama', timezone: 'America/Chicago'},
      {code: 'AK', country: 'US', name: 'Alaska', timezone: 'America/Anchorage'},
      {code: 'AS', country: 'US', name: 'American Samoa', timezone: 'US/Samoa'}, //no zone
      {code: 'AZ', country: 'US', name: 'Arizona', timezone: 'America/Phoenix'},
      {code: 'AR', country: 'US', name: 'Arkansas', timezone: 'America/Chicago'},
      {code: 'CA', country: 'US', name: 'California', timezone: 'America/Los_Angeles'},
      {code: 'CO', country: 'US', name: 'Colorado', timezone: 'America/Denver'},
      {code: 'CT', country: 'US', name: 'Connecticut', timezone: 'America/New_York'},
      {code: 'DE', country: 'US', name: 'Delaware', timezone: 'America/New_York'},
      {code: 'DC', country: 'US', name: 'District Of Columbia', timezone: 'America/New_York'},
      {code: 'FM', country: 'US', name: 'Federated States Of Micronesia', timezone: 'Pacific/Pohnpei'}, //no zone
      {code: 'FL', country: 'US', name: 'Florida', timezone: 'America/New_York'},
      {code: 'GA', country: 'US', name: 'Georgia', timezone: 'America/New_York'},
      {code: 'GU', country: 'US', name: 'Guam', timezone: 'Pacific/Guam'}, //no zone
      {code: 'HI', country: 'US', name: 'Hawaii', timezone: 'US/Hawaii'},
      {code: 'ID', country: 'US', name: 'Idaho', timezone: 'America/Boise'},
      {code: 'IL', country: 'US', name: 'Illinois', timezone: 'America/Chicago'},
      {code: 'IN', country: 'US', name: 'Indiana', timezone: 'America/Indianapolis'},
      {code: 'IA', country: 'US', name: 'Iowa', timezone: 'America/Chicago'},
      {code: 'KS', country: 'US', name: 'Kansas', timezone: 'America/Chicago'},
      {code: 'KY', country: 'US', name: 'Kentucky', timezone: 'America/Chicago'},
      {code: 'LA', country: 'US', name: 'Louisiana', timezone: 'America/Chicago'},
      {code: 'ME', country: 'US', name: 'Maine', timezone: 'America/New_York'},
      {code: 'MH', country: 'US', name: 'Marshall Islands', timezone: 'Pacific/Majuro'}, //no zone
      {code: 'MD', country: 'US', name: 'Maryland', timezone: 'America/New_York'},
      {code: 'MA', country: 'US', name: 'Massachusetts', timezone: 'America/New_York'},
      {code: 'MI', country: 'US', name: 'Michigan', timezone: 'America/Detroit'},
      {code: 'MN', country: 'US', name: 'Minnesota', timezone: 'America/Chicago'},
      {code: 'MS', country: 'US', name: 'Mississippi', timezone: 'America/Chicago'},
      {code: 'MO', country: 'US', name: 'Missouri', timezone: 'America/Chicago'},
      {code: 'MT', country: 'US', name: 'Montana', timezone: 'America/Denver'},
      {code: 'NE', country: 'US', name: 'Nebraska', timezone: 'America/Chicago'},
      {code: 'NV', country: 'US', name: 'Nevada', timezone: 'America/Los_Angeles'},
      {code: 'NH', country: 'US', name: 'New Hampshire', timezone: 'America/New_York'},
      {code: 'NJ', country: 'US', name: 'New Jersey', timezone: 'America/New_York'},
      {code: 'NM', country: 'US', name: 'New Mexico', timezone: 'America/Denver'},
      {code: 'NY', country: 'US', name: 'New York', timezone: 'America/New_York'},
      {code: 'NC', country: 'US', name: 'North Carolina', timezone: 'America/New_York'},
      {code: 'ND', country: 'US', name: 'North Dakota', timezone: 'America/Chicago'},
      {code: 'MP', country: 'US', name: 'Northern Mariana Islands', timezone: 'Pacific/Saipan'}, //no zone
      {code: 'OH', country: 'US', name: 'Ohio', timezone: 'America/New_York'},
      {code: 'OK', country: 'US', name: 'Oklahoma', timezone: 'America/Chicago'},
      {code: 'OR', country: 'US', name: 'Oregon', timezone: 'America/Los_Angeles'},
      {code: 'PW', country: 'US', name: 'Palau', timezone: 'Pacific/Palau'}, //no zone
      {code: 'PA', country: 'US', name: 'Pennsylvania', timezone: 'America/New_York'},
      {code: 'PR', country: 'US', name: 'Puerto Rico', timezone: 'America/Puerto_Rico'}, //no zone
      {code: 'RI', country: 'US', name: 'Rhode Island', timezone: 'America/New_York'},
      {code: 'SC', country: 'US', name: 'South Carolina', timezone: 'America/New_York'},
      {code: 'SD', country: 'US', name: 'South Dakota', timezone: 'America/Chicago'},
      {code: 'TN', country: 'US', name: 'Tennessee', timezone: 'America/Chicago'},
      {code: 'TX', country: 'US', name: 'Texas', timezone: 'America/Chicago'},
      {code: 'UT', country: 'US', name: 'Utah', timezone: 'America/Denver'},
      {code: 'VT', country: 'US', name: 'Vermont', timezone: 'America/New_York'},
      {code: 'VI', country: 'US', name: 'Virgin Islands', timezone: 'America/St_Thomas'}, //no zone
      {code: 'VA', country: 'US', name: 'Virginia', timezone: 'America/New_York'},
      {code: 'WA', country: 'US', name: 'Washington', timezone: 'America/Los_Angeles'},
      {code: 'WV', country: 'US', name: 'West Virginia', timezone: 'America/New_York'},
      {code: 'WI', country: 'US', name: 'Wisconsin', timezone: 'America/Chicago'},
      {code: 'WY', country: 'US', name: 'Wyoming', timezone: 'America/Denver'},
      // Australia
      {code: 'ACT', country: 'AU', name: 'Australian Capital Territory', timezone: 'Australia/Sydney'},
      {code: 'NSW', country: 'AU', name: 'New South Wales', timezone: 'Australia/Sydney'},
      {code: 'NT', country: 'AU', name: 'Northern Territory', timezone: 'Australia/Darwin'},
      {code: 'QLD', country: 'AU', name: 'Queensland', timezone: 'Australia/Brisbane'},
      {code: 'SA', country: 'AU', name: 'South Australia', timezone: 'Australia/Adelaide'},
      {code: 'TAS', country: 'AU', name: 'Tasmania', timezone: 'Australia/Hobart'},
      {code: 'VIC', country: 'AU', name: 'Victoria', timezone: 'Australia/Melbourne'},
      {code: 'WA', country: 'AU', name: 'Western Australia', timezone: 'Australia/Perth'},
      {code: 'JBT', country: 'AU', name: 'Jervis Bay Territory', timezone: 'Australia/Sydney'},
    ];


  static Countries = [
      {code: 'CA', name: 'Canada'},
      {code: 'US', name: 'United States'},
      {code: 'GB', name: 'United Kingdom'},
      {code: 'AU', name: 'Australia'},
      {code: 'NZ', name: 'New Zealand'},
      {code: 'XX', name: '--------------'},
      {code: 'AF', name: 'Afghanistan'},
      {code: 'AL', name: 'Albania'},
      {code: 'DZ', name: 'Algeria'},
      {code: 'AS', name: 'American Samoa'},
      {code: 'AD', name: 'Andorra'},
      {code: 'AO', name: 'Angola'},
      {code: 'AI', name: 'Anguilla'},
      {code: 'AQ', name: 'Antarctica'},
      {code: 'AG', name: 'Antigua and Barbuda'},
      {code: 'AR', name: 'Argentina'},
      {code: 'AM', name: 'Armenia'},
      {code: 'AW', name: 'Aruba'},
      {code: 'AT', name: 'Austria'},
      {code: 'AZ', name: 'Azerbaijan'},
      {code: 'BS', name: 'Bahamas (the)'},
      {code: 'BH', name: 'Bahrain'},
      {code: 'BD', name: 'Bangladesh'},
      {code: 'BB', name: 'Barbados'},
      {code: 'BY', name: 'Belarus'},
      {code: 'BE', name: 'Belgium'},
      {code: 'BZ', name: 'Belize'},
      {code: 'BJ', name: 'Benin'},
      {code: 'BM', name: 'Bermuda'},
      {code: 'BT', name: 'Bhutan'},
      {code: 'BO', name: 'Bolivia (Plurinational State of)'},
      {code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba'},
      {code: 'BA', name: 'Bosnia and Herzegovina'},
      {code: 'BW', name: 'Botswana'},
      {code: 'BV', name: 'Bouvet Island'},
      {code: 'BR', name: 'Brazil'},
      {code: 'IO', name: 'British Indian Ocean Territory (the)'},
      {code: 'BN', name: 'Brunei Darussalam'},
      {code: 'BG', name: 'Bulgaria'},
      {code: 'BF', name: 'Burkina Faso'},
      {code: 'BI', name: 'Burundi'},
      {code: 'CV', name: 'Cabo Verde'},
      {code: 'KH', name: 'Cambodia'},
      {code: 'CM', name: 'Cameroon'},
      {code: 'KY', name: 'Cayman Islands (the)'},
      {code: 'CF', name: 'Central African Republic (the)'},
      {code: 'TD', name: 'Chad'},
      {code: 'CL', name: 'Chile'},
      {code: 'CN', name: 'China'},
      {code: 'CX', name: 'Christmas Island'},
      {code: 'CC', name: 'Cocos (Keeling) Islands (the)'},
      {code: 'CO', name: 'Colombia'},
      {code: 'KM', name: 'Comoros (the)'},
      {code: 'CD', name: 'Congo (the Democratic Republic of the)'},
      {code: 'CG', name: 'Congo (the)'},
      {code: 'CK', name: 'Cook Islands (the)'},
      {code: 'CR', name: 'Costa Rica'},
      {code: 'HR', name: 'Croatia'},
      {code: 'CU', name: 'Cuba'},
      {code: 'CW', name: 'Curaçao'},
      {code: 'CY', name: 'Cyprus'},
      {code: 'CZ', name: 'Czechia'},
      {code: 'CI', name: 'Côte d\'Ivoire'},
      {code: 'DK', name: 'Denmark'},
      {code: 'DJ', name: 'Djibouti'},
      {code: 'DM', name: 'Dominica'},
      {code: 'DO', name: 'Dominican Republic (the)'},
      {code: 'EC', name: 'Ecuador'},
      {code: 'EG', name: 'Egypt'},
      {code: 'SV', name: 'El Salvador'},
      {code: 'GQ', name: 'Equatorial Guinea'},
      {code: 'ER', name: 'Eritrea'},
      {code: 'EE', name: 'Estonia'},
      {code: 'SZ', name: 'Eswatini'},
      {code: 'ET', name: 'Ethiopia'},
      {code: 'FK', name: 'Falkland Islands (the) [Malvinas]'},
      {code: 'FO', name: 'Faroe Islands (the)'},
      {code: 'FJ', name: 'Fiji'},
      {code: 'FI', name: 'Finland'},
      {code: 'FR', name: 'France'},
      {code: 'GF', name: 'French Guiana'},
      {code: 'PF', name: 'French Polynesia'},
      {code: 'TF', name: 'French Southern Territories (the)'},
      {code: 'GA', name: 'Gabon'},
      {code: 'GM', name: 'Gambia (the)'},
      {code: 'GE', name: 'Georgia'},
      {code: 'DE', name: 'Germany'},
      {code: 'GH', name: 'Ghana'},
      {code: 'GI', name: 'Gibraltar'},
      {code: 'GR', name: 'Greece'},
      {code: 'GL', name: 'Greenland'},
      {code: 'GD', name: 'Grenada'},
      {code: 'GP', name: 'Guadeloupe'},
      {code: 'GU', name: 'Guam'},
      {code: 'GT', name: 'Guatemala'},
      {code: 'GG', name: 'Guernsey'},
      {code: 'GN', name: 'Guinea'},
      {code: 'GW', name: 'Guinea-Bissau'},
      {code: 'GY', name: 'Guyana'},
      {code: 'HT', name: 'Haiti'},
      {code: 'HM', name: 'Heard Island and McDonald Islands'},
      {code: 'VA', name: 'Holy See (the)'},
      {code: 'HN', name: 'Honduras'},
      {code: 'HK', name: 'Hong Kong'},
      {code: 'HU', name: 'Hungary'},
      {code: 'IS', name: 'Iceland'},
      {code: 'IN', name: 'India'},
      {code: 'ID', name: 'Indonesia'},
      {code: 'IR', name: 'Iran (Islamic Republic of)'},
      {code: 'IQ', name: 'Iraq'},
      {code: 'IE', name: 'Ireland'},
      {code: 'IM', name: 'Isle of Man'},
      {code: 'IL', name: 'Israel'},
      {code: 'IT', name: 'Italy'},
      {code: 'JM', name: 'Jamaica'},
      {code: 'JP', name: 'Japan'},
      {code: 'JE', name: 'Jersey'},
      {code: 'JO', name: 'Jordan'},
      {code: 'KZ', name: 'Kazakhstan'},
      {code: 'KE', name: 'Kenya'},
      {code: 'KI', name: 'Kiribati'},
      {code: 'KP', name: 'Korea (the Democratic People\'s Republic of)'},
      {code: 'KR', name: 'Korea (the Republic of)'},
      {code: 'KW', name: 'Kuwait'},
      {code: 'KG', name: 'Kyrgyzstan'},
      {code: 'LA', name: 'Lao People\'s Democratic Republic (the)'},
      {code: 'LV', name: 'Latvia'},
      {code: 'LB', name: 'Lebanon'},
      {code: 'LS', name: 'Lesotho'},
      {code: 'LR', name: 'Liberia'},
      {code: 'LY', name: 'Libya'},
      {code: 'LI', name: 'Liechtenstein'},
      {code: 'LT', name: 'Lithuania'},
      {code: 'LU', name: 'Luxembourg'},
      {code: 'MO', name: 'Macao'},
      {code: 'MG', name: 'Madagascar'},
      {code: 'MW', name: 'Malawi'},
      {code: 'MY', name: 'Malaysia'},
      {code: 'MV', name: 'Maldives'},
      {code: 'ML', name: 'Mali'},
      {code: 'MT', name: 'Malta'},
      {code: 'MH', name: 'Marshall Islands (the)'},
      {code: 'MQ', name: 'Martinique'},
      {code: 'MR', name: 'Mauritania'},
      {code: 'MU', name: 'Mauritius'},
      {code: 'YT', name: 'Mayotte'},
      {code: 'MX', name: 'Mexico'},
      {code: 'FM', name: 'Micronesia (Federated States of)'},
      {code: 'MD', name: 'Moldova (the Republic of)'},
      {code: 'MC', name: 'Monaco'},
      {code: 'MN', name: 'Mongolia'},
      {code: 'ME', name: 'Montenegro'},
      {code: 'MS', name: 'Montserrat'},
      {code: 'MA', name: 'Morocco'},
      {code: 'MZ', name: 'Mozambique'},
      {code: 'MM', name: 'Myanmar'},
      {code: 'NA', name: 'Namibia'},
      {code: 'NR', name: 'Nauru'},
      {code: 'NP', name: 'Nepal'},
      {code: 'NL', name: 'Netherlands (the)'},
      {code: 'NC', name: 'New Caledonia'},
      {code: 'NI', name: 'Nicaragua'},
      {code: 'NE', name: 'Niger (the)'},
      {code: 'NG', name: 'Nigeria'},
      {code: 'NU', name: 'Niue'},
      {code: 'NF', name: 'Norfolk Island'},
      {code: 'MP', name: 'Northern Mariana Islands (the)'},
      {code: 'NO', name: 'Norway'},
      {code: 'OM', name: 'Oman'},
      {code: 'PK', name: 'Pakistan'},
      {code: 'PW', name: 'Palau'},
      {code: 'PS', name: 'Palestine, State of'},
      {code: 'PA', name: 'Panama'},
      {code: 'PG', name: 'Papua New Guinea'},
      {code: 'PY', name: 'Paraguay'},
      {code: 'PE', name: 'Peru'},
      {code: 'PH', name: 'Philippines (the)'},
      {code: 'PN', name: 'Pitcairn'},
      {code: 'PL', name: 'Poland'},
      {code: 'PT', name: 'Portugal'},
      {code: 'PR', name: 'Puerto Rico'},
      {code: 'QA', name: 'Qatar'},
      {code: 'MK', name: 'Republic of North Macedonia'},
      {code: 'RO', name: 'Romania'},
      {code: 'RU', name: 'Russian Federation (the)'},
      {code: 'RW', name: 'Rwanda'},
      {code: 'RE', name: 'Réunion'},
      {code: 'BL', name: 'Saint Barthélemy'},
      {code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha'},
      {code: 'KN', name: 'Saint Kitts and Nevis'},
      {code: 'LC', name: 'Saint Lucia'},
      {code: 'MF', name: 'Saint Martin (French part)'},
      {code: 'PM', name: 'Saint Pierre and Miquelon'},
      {code: 'VC', name: 'Saint Vincent and the Grenadines'},
      {code: 'WS', name: 'Samoa'},
      {code: 'SM', name: 'San Marino'},
      {code: 'ST', name: 'Sao Tome and Principe'},
      {code: 'SA', name: 'Saudi Arabia'},
      {code: 'SN', name: 'Senegal'},
      {code: 'RS', name: 'Serbia'},
      {code: 'SC', name: 'Seychelles'},
      {code: 'SL', name: 'Sierra Leone'},
      {code: 'SG', name: 'Singapore'},
      {code: 'SX', name: 'Sint Maarten (Dutch part)'},
      {code: 'SK', name: 'Slovakia'},
      {code: 'SI', name: 'Slovenia'},
      {code: 'SB', name: 'Solomon Islands'},
      {code: 'SO', name: 'Somalia'},
      {code: 'ZA', name: 'South Africa'},
      {code: 'GS', name: 'South Georgia and the South Sandwich Islands'},
      {code: 'SS', name: 'South Sudan'},
      {code: 'ES', name: 'Spain'},
      {code: 'LK', name: 'Sri Lanka'},
      {code: 'SD', name: 'Sudan (the)'},
      {code: 'SR', name: 'Suriname'},
      {code: 'SJ', name: 'Svalbard and Jan Mayen'},
      {code: 'SE', name: 'Sweden'},
      {code: 'CH', name: 'Switzerland'},
      {code: 'SY', name: 'Syrian Arab Republic'},
      {code: 'TW', name: 'Taiwan'},
      {code: 'TJ', name: 'Tajikistan'},
      {code: 'TZ', name: 'Tanzania, United Republic of'},
      {code: 'TH', name: 'Thailand'},
      {code: 'TL', name: 'Timor-Leste'},
      {code: 'TG', name: 'Togo'},
      {code: 'TK', name: 'Tokelau'},
      {code: 'TO', name: 'Tonga'},
      {code: 'TT', name: 'Trinidad and Tobago'},
      {code: 'TN', name: 'Tunisia'},
      {code: 'TR', name: 'Turkey'},
      {code: 'TM', name: 'Turkmenistan'},
      {code: 'TC', name: 'Turks and Caicos Islands (the)'},
      {code: 'TV', name: 'Tuvalu'},
      {code: 'UG', name: 'Uganda'},
      {code: 'UA', name: 'Ukraine'},
      {code: 'AE', name: 'United Arab Emirates (the)'},
      {code: 'UM', name: 'United States Minor Outlying Islands (the)'},
      {code: 'UY', name: 'Uruguay'},
      {code: 'UZ', name: 'Uzbekistan'},
      {code: 'VU', name: 'Vanuatu'},
      {code: 'VE', name: 'Venezuela (Bolivarian Republic of)'},
      {code: 'VN', name: 'Viet Nam'},
      {code: 'VG', name: 'Virgin Islands (British)'},
      {code: 'VI', name: 'Virgin Islands (U.S.)'},
      {code: 'WF', name: 'Wallis and Futuna'},
      {code: 'EH', name: 'Western Sahara'},
      {code: 'YE', name: 'Yemen'},
      {code: 'ZM', name: 'Zambia'},
      {code: 'ZW', name: 'Zimbabwe'},
      {code: 'AX', name: 'Åland Islands'}
    ];
}